import React, { useMemo, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/CustomersApi/Customers";
import { validateForm } from "utils/validation";
import { CustomersRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditCustomerForm from "./Componates/EditCustomerForm";
import fields from "../json/CustomersFeilds.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";




export const formDateToMysqlDate = (value) => {
  if (!value) return "";

  const date = String(value).trim();

  if (!/^\d{2}-\d{2}-\d{4}$/.test(date)) {
    return value;
  }

  const [day, month, year] = date.split("-");

  return `${year}-${month}-${day}`;
};

const EditCustomer = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // Dynamically extract all form fields from any section except tabledata
  const allFields = useMemo(
    () => Object.keys(fields).filter((k) => k !== "tabledata").flatMap((k) => fields[k] || []),
    []
  );

  const fileFieldNames = useMemo(
    () => allFields.filter((f) => f.type === "file").map((f) => f.name),
    [allFields]
  );

  const initialValues = useMemo(() => {
    const init = allFields.reduce((acc, field) => {
      acc[field.name] = field.type === "switch" ? field.ValueOne || "active" : "";
      return acc;
    }, {});
    if (!init.country_dial_code) init.country_dial_code = "+91";
    return init;
  }, [allFields]);

  const { values, errors, handleChange, handleFileChange, setErrors, setValues } =
    useFormChange(initialValues, CustomersRules);



  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    allFields,
    GetById,
    setValues
  );

  const filePreviews = useMemo(() => {
    return fileFieldNames.reduce((acc, name) => {
      acc[name] = values[`${name}Preview`] || values[name];
      return acc;
    }, {});
  }, [fileFieldNames, values]);

  const cleanValues = (vals) => {
    const cleaned = { ...vals };

    fileFieldNames.forEach((name) => {
      delete cleaned[`${name}Preview`];
      // Drop file fields that are still strings (existing URLs from the API) —
      // only send new File uploads to the server.
      if (typeof cleaned[name] === "string") delete cleaned[name];
    });

    return cleaned;
  };

  const mysqlDateToFormDate = (value) => {
    if (!value) return "";

    const date = String(value).split("T")[0];

    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return value;
    }

    const [year, month, day] = date.split("-");

    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    if (values.dob) {
      setValues({
        ...values,
        dob: mysqlDateToFormDate(values.dob),
      });
    }
  }, [values.dob]);



  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const cleanedValues = cleanValues(formValues);
      const formData = new FormData();
      Object.entries(cleanedValues).forEach(([key, val]) => {
        if (val instanceof File) {
          formData.append(key, val);
        } else if (val !== undefined && val !== null) {
          if (key == "dob") {
            formData.append(key, formDateToMysqlDate(val));
          } else {
            formData.append(key, String(val));
          }
        }
      });
      return await Update({ id, data: formData });
    },
    (vals) => {
      const cleanedValues = cleanValues(vals);
      const err = validateForm(cleanedValues, CustomersRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Customer Updated successfully!"
  );

  return (
    <>
      {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
      <EditCustomerForm
        fields={fields}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        handleFileChange={handleFileChange}
        title="Update Customer"
        filePreviews={filePreviews}
      />
    </>
  );
};

export default EditCustomer;